



















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';

@Component({
  components: {
  },
})
export default class Modal extends Vue {
  @Prop({ type: Boolean, default: true })
  public showCloseButton = true;

  @Prop({ type: Boolean, default: false })
  public visible!: boolean;

  @Prop({ type: String, required: false })
  public title?: string;

  get isModalVisible() {
    return this.visible;
  }
}
